import * as PIXI from 'pixi.js';
import { state } from '__common/store';
import { getRoofEdgesPointsInPx } from '../components/background/background';
import Polygon from 'polygon';
import { degreesToRadians } from 'maths';
import { getScaleFromPitchRoof } from '../components/tiltedRoof/tiltedRoof';

function fogOfWar(width: number, height: number, resizedY: number) {
  const fogOfWar = createFogOfWarGraphicObject(width, height);
  const holePoint = getRotatedPolyPixelPoints();
  createHoleInPolygon(fogOfWar, holePoint);
  rescaleFogOfWarIfRoofPitch(fogOfWar, resizedY);

  return fogOfWar;
}

function createFogOfWarGraphicObject(width: number, height: number) {
  const fogOfWar = new PIXI.Graphics();
  fogOfWar.beginFill(0x000000);
  fogOfWar.moveTo(0, 0);
  fogOfWar.lineTo(width, 0);
  fogOfWar.lineTo(width, height);
  fogOfWar.lineTo(0, height);
  fogOfWar.closePath();

  fogOfWar.id = 'fogOfWar';
  fogOfWar.zIndex = 9999;
  fogOfWar.alpha = 0.70;

  return fogOfWar;
}

function createHoleInPolygon(fogOfWar: PIXI.Graphics, holePoint: {x: number, y: number}[]) {
  fogOfWar.beginHole();
  holePoint.map((point, index) => {
    if (index === 0) {
      fogOfWar.moveTo(point.x, point.y);
    } else {
      fogOfWar.lineTo(point.x, point.y);
    }
  });
  fogOfWar.closePath();
  fogOfWar.endHole();
  fogOfWar.endFill();
}

function rescaleFogOfWarIfRoofPitch(fogOfWar: PIXI.Graphics, resizedY: number) {
  const {
    background: { bgXY },
    tiltedRoof: { roofPitch },
    projectConfiguration: { productId },
  } = state();
  const scale = getScaleFromPitchRoof(roofPitch, productId);
  fogOfWar.y -= (bgXY.y - resizedY) * scale || 0;
  fogOfWar.scale.y = scale;
}

export function getRotatedPolyPixelPoints() {
  const currentState = state();
  const {
    background: { roofEdges, cords, zoom, rotationDegrees },
    settings: { canvasCenter },
  } = currentState;

  const cordsInPx = getRoofEdgesPointsInPx(roofEdges, cords, zoom, currentState);
  const movedCordsInPx = cordsInPx.map((point) => {
    return {
      x: point.x + canvasCenter.x,
      y: point.y + canvasCenter.y,
    };
  });
  const polygon = new Polygon(movedCordsInPx);
  polygon.scale(2);
  polygon.rotate(degreesToRadians(rotationDegrees));

  return polygon.points;
}

export default fogOfWar;
